import { c as _c } from "react/compiler-runtime";
import { Box, Button, Container as MuiContainer, Theme } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { config } from '../theme';
import { Fragment, JSX, ReactNode, use } from 'react';
import { LayoutContext } from '..';
import Breadcrumbs from '../Breadcrumbs';
import GlobalContext from '../Providers/GlobalContext';
import { ContentLoader, ContentError } from '../ContentLoading';
import { useTranslation } from 'react-i18next';
import { useAuth0 } from '@auth0/auth0-react';
import { resetCaches } from '@apollo/client';
const Container = t0 => {
  const $ = _c(21);
  const {
    children
  } = t0;
  const {
    logout
  } = useAuth0();
  const {
    t
  } = useTranslation();
  const {
    pageLoading,
    pageError,
    currentOrganisation,
    organisations,
    user,
    role,
    language
  } = use(GlobalContext);
  const {
    isMobile,
    drawerOpen
  } = use(LayoutContext);
  const theme = useTheme();
  let t1;
  if ($[0] !== children || $[1] !== currentOrganisation || $[2] !== language || $[3] !== logout || $[4] !== organisations || $[5] !== pageError || $[6] !== pageLoading || $[7] !== role || $[8] !== t || $[9] !== user) {
    t1 = () => {
      if (pageLoading) {
        return <ContentLoader />;
      }
      if (!role) {
        return <ContentError message={t("styra.message.missing_role")}><Box sx={{
            pt: 2
          }}><Button sx={{
              borderRadius: 999,
              px: 8
            }} size="large" variant="contained" color="error" onClick={() => {
              localStorage.clear();
              sessionStorage.clear();
              resetCaches();
              logout(window?.location?.origin ? {
                logoutParams: {
                  returnTo: window.location.origin
                },
                clientId: process.env.NEXT_PUBLIC_AUTH0_CLIENTID || ""
              } : {});
            }}>{t("general.log_out")}</Button></Box></ContentError>;
      }
      if (pageError || !user) {
        return <ContentError />;
      }
      if (!organisations.length) {
        return <ContentError message={t("styra.message.no_organisation")} />;
      }
      if (!currentOrganisation) {
        return <ContentError message={t("styra.message.select_organisation")} />;
      }
      return <Fragment key={language}>{children}</Fragment>;
    };
    $[0] = children;
    $[1] = currentOrganisation;
    $[2] = language;
    $[3] = logout;
    $[4] = organisations;
    $[5] = pageError;
    $[6] = pageLoading;
    $[7] = role;
    $[8] = t;
    $[9] = user;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  const renderContent = t1;
  let t2;
  if ($[11] !== drawerOpen || $[12] !== isMobile || $[13] !== theme) {
    t2 = styles(theme, drawerOpen, isMobile);
    $[11] = drawerOpen;
    $[12] = isMobile;
    $[13] = theme;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Breadcrumbs />;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== renderContent) {
    t4 = renderContent();
    $[16] = renderContent;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== t2 || $[19] !== t4) {
    t5 = <MuiContainer component="main" disableGutters={true} sx={t2} maxWidth={false}>{t3}{t4}</MuiContainer>;
    $[18] = t2;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
};
export default Container;
export const UnauthorizedContainer = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  const {
    isMobile,
    drawerOpen
  } = use(LayoutContext);
  const theme = useTheme();
  let t1;
  if ($[0] !== drawerOpen || $[1] !== isMobile || $[2] !== theme) {
    t1 = styles(theme, drawerOpen, isMobile);
    $[0] = drawerOpen;
    $[1] = isMobile;
    $[2] = theme;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== t1) {
    t2 = <MuiContainer component="main" disableGutters={true} sx={t1} maxWidth={false}>{children}</MuiContainer>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
const styles = (theme: Theme, open: boolean, isMobile: boolean) => ({
  minHeight: '100dvh',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#F8F8FA',
  padding: 3,
  paddingTop: 10,
  paddingBottom: 0,
  position: 'relative',
  flexGrow: 1,
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  marginLeft: isMobile ? 0 : `-${config.drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginLeft: 0
  })
});